import type { ProductVariant } from '~~/types/commercetools';

import type { ProductVariantExtended } from '~~/types/product/ProductVariantExtended';

export const useProductRecommendationEvents = ({
  sourceProductSku,
  suggestedAccessories,
  suggestedParentProducts,
  suggestedSimilarProducts,
  suggestedCartRecommendations,
}: {
  sourceProductSku: string,
  suggestedAccessories?: ProductVariant[],
  suggestedCartRecommendations?: ProductVariantExtended[],
  suggestedParentProducts?: ProductVariant[],
  suggestedSimilarProducts?: ProductVariant[] | ProductVariantExtended[],
}) => {

  const {
    trackViewAccessories,
    trackViewParentProducts,
    trackViewSimilarProducts,
    trackViewCartRecommendations,
    trackClickAccessory,
    trackClickParentProduct,
  } = useGtmEvents();

  const { onIntersectOnce: onIntersectAccessoriesOnce } = useIntersectionObserverEvent({
    onIntersectCallback: () => {

      if (suggestedAccessories?.length && sourceProductSku) {

        trackViewAccessories(suggestedAccessories, sourceProductSku);
      
      }
    
    },
  });

  const { onIntersectOnce: onIntersectParentProductsOnce } = useIntersectionObserverEvent({
    onIntersectCallback: () => {

      if (suggestedParentProducts?.length && sourceProductSku) {

        trackViewParentProducts(suggestedParentProducts, sourceProductSku);
      
      }
    
    },
  });

  const { onIntersectOnce: onIntersectSimilarProductsOnce } = useIntersectionObserverEvent({
    onIntersectCallback: () => {

      if (suggestedSimilarProducts?.length && sourceProductSku) {

        trackViewSimilarProducts(suggestedSimilarProducts, sourceProductSku);
      
      }
    
    },
  });

  const { onIntersectOnce: onIntersectCartRecommendationsOnce } = useIntersectionObserverEvent({
    onIntersectCallback: () => {

      if (suggestedCartRecommendations?.length && sourceProductSku) {

        trackViewCartRecommendations(suggestedCartRecommendations, sourceProductSku);
      
      }
    
    },
  });

  const onClickAccessory = (accessorySku: string) => {

    if (accessorySku && sourceProductSku) {

      trackClickAccessory(accessorySku, sourceProductSku);
    
    }
  
  };

  const onClickParentProduct = (parentSku: string) => {

    if (parentSku && sourceProductSku) {

      trackClickParentProduct(parentSku, sourceProductSku);
    
    }
  
  };

  return {
    onIntersectAccessoriesOnce,
    onIntersectParentProductsOnce,
    onIntersectSimilarProductsOnce,
    onClickAccessory,
    onClickParentProduct,
    onIntersectCartRecommendationsOnce,
  };

};
